import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=4d15bcc2&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&id=4d15bcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d15bcc2",
  null
  
)

export default component.exports